import { createSelector } from '@reduxjs/toolkit';

import { HangerList } from '@paragon/contract-library';

import { useAppSelector } from '../components/hooks';
import { RootState } from '../store';

export const getMaterialSetPrototype = (state: RootState) => state.materialSetPrototype;

export const getHangerLists = createSelector([getMaterialSetPrototype], (materialSetPrototype) =>
  materialSetPrototype.status === 'loaded' ? Object.values(materialSetPrototype.hangerLists) : 'loading',
);

export function useHangerList(guid: string | undefined): HangerList | 'loading' | null {
  const materialSetPrototype = useAppSelector(getMaterialSetPrototype);
  if (materialSetPrototype.status !== 'loaded') return 'loading';

  return guid ? (materialSetPrototype.hangerLists[guid] ?? null) : null;
}
